export default __webpack_public_path__ + "static/media/about-me-cover.da8662a8.png";